import React, { useLayoutEffect } from 'react';
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { KeyboardArrowUp } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './components/Navbar/NavBar.js';
import Home from './components/Home/Home';
import Footer from './components/Footer/Footer';
import './App.css';
import About from "./components/About/About.js";
import Services from "./components/Services/Services.js";
import Pricing from "./components/Pricing/Pricing.js";
import Contact from "./components/Contact/Contact.js";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();


export default function App() {
  const location = useLocation();
  // Scroll to top if path changes
  const gotoTop = () => {
    window.scrollTo(0, 0)
  }
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />}>
        </Route>
        <Route path="/about" element={<About />}>
        </Route>
        <Route path="/services" element={<Services />}>
        </Route>
        {/* <Route path="/pricing" element={<Pricing />}>
        </Route> */}
        <Route path="/contact" element={<Contact />}>
        </Route>
      </Routes>
      <Footer />
      <IconButton className="gotoTop" color="primary" onClick={gotoTop}>
        <KeyboardArrowUp />
      </IconButton>

    </>
  );
}